import { truncate } from 'lodash';
import getFileExtension from './getFileExtension';

const truncateFilename = (filename, maxSymbols) => {
  const extension = getFileExtension(filename);

  return (
    truncate(filename, {
      length: maxSymbols,
      separator: '.',
    }) + (filename.length > maxSymbols ? extension : '')
  );
};

export default truncateFilename;
